import React from 'react';
import { Typography } from '@material-ui/core';

function RejectedScreen() {
  return (
    <Typography variant="h1" color={'error'} align={'center'}>
      Verification rejected
    </Typography>
  );
}

export default RejectedScreen;
